import React from "react";
import InvItemAttrs from "../../../inv/components/InvItemAttrs"
import withView from '../../../cmn/docAutomation/withView';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormWrapper from '../../../../library/form/components/FormWrapper'

const ItemQVHeader = (props) => {
    const { formObject } = props;

    return (
        <div style={{backgroundColor:"#ffffff"}}>
            <ul>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docId" }} value="ID" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docId" }} className="uiVal" />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Name" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemName" }} className="uiVal" />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mainUnit" }} value="Main Unit" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "mainUnit" }} className="uiVal" />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCat1" }} value="Category 1" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemCat1" }} className="uiVal" />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCat2" }} value="Category 2" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemCat2" }} className="uiVal" />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "stockInHand" }} value="SIH" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "stockInHand" }} className="uiVal" />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemAttrs" }} >
                    <InvItemAttrs formObject={formObject} rowKey="" action={{ paramName: "itemAttrs" }} />
                </FormWrapper>
                
            </ul>
        </div>
    )
}

export default withView(ItemQVHeader, "", "");